import React, { ReactNode } from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Logo from "../assets/Logo.svg";

type OnboardingLayoutProps = {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  showHeader?: boolean;
  maxWidth?: number;
  hasSidebar?: boolean;
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#0C0A09",
    padding: "48px 16px 64px",
    boxSizing: "border-box",
    "& .MuiPaper-root": {
      backgroundColor: "transparent",
    },
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    marginBottom: 32,
  },
  logo: {
    width: 172,
    height: "auto",
    [theme.breakpoints.down("sm")]: {
      width: 140,
    },
  },
  title: {
    color: "#FFFFFF",
    fontSize: 32,
    fontWeight: 600,
    textAlign: "center",
    lineHeight: 1.2,
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
    },
  },
  subtitle: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: 500,
    textAlign: "center",
    lineHeight: 1.5,
    maxWidth: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
  },
  content: {
    width: "100%",
    borderRadius: 16,
    padding: 40,
    boxSizing: "border-box",
    boxShadow: "0px 20px 60px rgba(0, 0, 0, 0.4)",
    border: 0,
    [theme.breakpoints.down("sm")]: {
      padding: "32px 14px",
    },
  },
  contentWithBg: {
    backgroundColor: "#131313",
  },
  contentWithoutBg: {
    boxShadow: "none"
  },
}));

export default function OnboardingLayout({
  title = "Wellcome to Sugar Cribs!",
  subtitle = "Please follow our quick introduction so we will set up your profile",
  children,
  showHeader = true,
  maxWidth = 880,
  hasSidebar = false,
}: OnboardingLayoutProps) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {showHeader && (
        <Box className={classes.header}>
          <img src={Logo} alt="Sugar Cribs logo" className={classes.logo} />
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        </Box>
      )}

      <Box
        className={`${classes.content} ${!hasSidebar ? classes.contentWithBg : classes.contentWithoutBg}`}
        style={{ maxWidth }}
      >
        {children}
      </Box>
    </Box>
  );
}
